// Third Party
import { v4 as uuidv4 } from "uuid";

// MUI
import { Box, Grid, Skeleton, Stack, Typography } from "@mui/material";

// Constants
const BORDER_RADIUS = "rounded-md";
const maxHeight = 150;
const randomHeightArrayLessThan200 = Array.from({ length: 30 }, () => {
	return {
		value: Math.floor(Math.random() * maxHeight),
		topPosition: Math.floor(Math.random() * 100),
		index: uuidv4(),
	};
});

const tabsSkeletonArray = [1, 2, 3, 4, 5];
export default function SalesLogAnalyticsSkeleton() {
	return (
		<Box pt={4} pb={6}>
			<Skeleton variant="rectangular" height={25} width={350} className={`${BORDER_RADIUS}`} />
			<Stack direction={"row"} spacing={2} justifySelf={"center"} mt={4.5}>
				{Array.from(tabsSkeletonArray).map((value) => (
					<Skeleton key={value} variant="rectangular" height={30} width={100} className={`${BORDER_RADIUS} mb-[15px]`} />
				))}
			</Stack>
			<Grid container direction="row" columnSpacing={3.5} mt={2} position={"relative"}>
				{/*Skeleton for DataSmartTable*/}
				<Grid item xs={4} className={"min-w-[150px] ml-[30px] min-h-[1px] absolute top-[25px] left-[20px]"}>
					<Stack spacing={2}>
						<Stack direction="row" spacing={2}>
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
						</Stack>
						<Skeleton variant="rectangular" width={330} height={20} className={BORDER_RADIUS} />
					</Stack>
				</Grid>
				{/* Skeleton for SpeedometerChart and its container */}
				<Grid item xs={12} className={"pt-[8px]"}>
					<Grid container direction="column" alignItems="center">
						<Grid item>
							<Typography className="page-title">
								<Skeleton width={400} className={"!mt-2"} />
							</Typography>
						</Grid>
						<Grid item my={4}>
							<Grid id="spedometer-design" container position={"relative"}>
								<Skeleton variant="circular" width={290} height={290} />
								<Box className={"absolute bg-white w-[300px] h-[200px] top-[150px] left-0"}></Box>
								<Box className={"absolute top-[20px] left-[20px] rounded-full bg-white w-[250px] h-[250px]"}></Box>
								<Box className={"absolute top-[85px] left-[70px]"}>
									<Skeleton width={150} height={70} />
								</Box>

								<Box className={"absolute bottom-[80px] left-0"}>
									<Skeleton width={300} height={20} />
								</Box>

								<Box className={"absolute bottom-[50px] left-0"}>
									<Skeleton width={140} height={20} />
								</Box>
								<Box className={"absolute bottom-[50px] right-[-10px]"}>
									<Skeleton width={140} height={20} />
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				{/*Skeleton for DataSmartTable*/}
				<Grid item xs={4} className={"min-w-[150px] ml-[100px] min-h-[1px] absolute top-[25px] right-[20px]"}>
					<Stack spacing={2}>
						<Stack direction="row" spacing={2}>
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
							<Skeleton variant="rectangular" width={100} height={20} className={BORDER_RADIUS} />
						</Stack>
						<Skeleton variant="rectangular" width={330} height={20} className={BORDER_RADIUS} />
					</Stack>
				</Grid>
				{/* Skeleton for SalesLogAccumulativeChart */}
				<Grid item xs={12}>
					<Stack direction="row" pt={3} spacing={10} paddingX={5} width={"50%"}>
						{[1, 2].map((key) => (
							<AccumulativeChartSkeleton key={key} title={key === 1 ? "Sales Gross Progress" : "Unit Volume Progress"} />
						))}
					</Stack>
				</Grid>
			</Grid>
		</Box>
	);
}

type AccumulativeChartSkeletonProps = {
	title: string;
};
function AccumulativeChartSkeleton(props: Readonly<AccumulativeChartSkeletonProps>) {
	return (
		<Box>
			<Typography className={"!font-[Montserrat] font-medium text-[#666666] !text-[18px] !mb-4"}>{props.title}</Typography>
			{/*Y-Axis*/}
			<Box position={"relative"}>
				<Skeleton variant="rectangular" width="4px" height={300} className={BORDER_RADIUS} />
				{/*X-Axis*/}
				<Skeleton variant="rectangular" width="600px" height={"4px"} className={BORDER_RADIUS} />
				{/*	Loop*/}
				{randomHeightArrayLessThan200.map((item, index) => (
					<Box key={item.index} position={"absolute"} left={(index + 1) * 10 + index * 9} top={item.topPosition}>
						<Skeleton
							variant="rectangular"
							width={"10px"}
							height={item.value}
							sx={{ marginRight: "20px" }}
							className={BORDER_RADIUS}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
}
